import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// Tab state that lives in the URL (ticket 81): `?tab=<key>` is readable,
// bookmarkable and survives reload. Replaces `useState(defaultKey)` one for one.
//
//   const [tab, setTab] = useTabParam('members', { valid: ['members', 'branches'] });
//
// - unknown / missing value → defaultKey (never crashes on a bad link)
// - writes use replace:true so tab clicks don't pile up in history
// - the default tab is written as "no param" so the plain URL stays canonical
// - `param` renames the query key when `tab` reads wrong (e.g. a board or track)
export function useTabParam(defaultKey, { param = 'tab', valid } = {}) {
  const [params, setParams] = useSearchParams();
  const raw = params.get(param);
  const value = raw && (!valid || valid.includes(raw)) ? raw : defaultKey;

  const setValue = useCallback((next) => {
    setParams((prev) => {
      const p = new URLSearchParams(prev);
      if (!next || next === defaultKey) p.delete(param);
      else p.set(param, next);
      return p;
    }, { replace: true });
  }, [setParams, param, defaultKey]);

  return [value, setValue];
}
